<template>
  <v-card class="charge-record" variant="text" :loading="loading" rounded="xl">
    <!-- 筛选栏 -->
    <div class="filter-bar">
      <div class="filter-item">
        <label class="filter-label date-label">请选择日期</label>
        <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始时间"
          end-placeholder="结束时间" value-format="YYYY-MM-DD" :disabled-date="disabledDate" :clearable="false"
          class="filter-date-picker" @change="handleDateChange" />
      </div>
      <div class="filter-item">
        <label class="filter-label">能量链</label>
        <v-select v-model="filterForm.eLinkIds" :items="eLinkList" item-title="label" item-value="value"
          placeholder="请选择能量链" variant="outlined" density="compact" class="filter-select"
          :menu-props="{ contentClass: 'charge-record-filter-select-menu' }" active-class="filter-select-active"
          @update:model-value="elinkChanged" />
      </div>
      <div class="filter-item">
        <label class="filter-label">能量块</label>
        <v-select v-model="filterForm.eBlockIds" :items="eBlockList" item-title="label" item-value="value"
          placeholder="请选择能量块" variant="outlined" density="compact" class="filter-select"
          :menu-props="{ contentClass: 'charge-record-filter-select-menu' }" active-class="filter-select-active"
          @update:model-value="handleSearch" />
      </div>
      <div class="filter-actions">
        <v-btn color="primary" class="query-btn" @click="handleSearch">
          <img src="@/assets/icons/svg/search-query.svg" alt="查询" class="query-icon" />
          查询
        </v-btn>
        <v-btn variant="outlined" class="export-btn" @click="handleExport">
          <img src="@/assets/icons/svg/export.svg" alt="导出" class="export-icon" />
          导出
        </v-btn>
        <v-btn variant="outlined" class="clear-btn" @click="handleReset">
          <img src="@/assets/icons/svg/reset.svg" alt="重置" class="reset-icon" />
          重置
        </v-btn>
      </div>
    </div>

    <!-- 表格容器 -->
    <div class="table-container">
      <div class="table-wrapper">
        <v-data-table :headers="tableHeaders" :items="tableData" :items-per-page="pagination.pageSize"
          :page="pagination.current" class="charge-table gm-table" item-value="key" hide-default-footer no-data-text="暂无数据">
          <template #item.chargeAndDischargeState="{ item }">
            <span class="charge-type-cell"
              :style="{ backgroundColor: chargeTypeMap.getBgColor(item.type), borderColor: chargeTypeMap.getBorderColor(item.type), color: chargeTypeMap.getTextColor(item.type) }">
              <component :is="chargeTypeMap.getComponent(item.type)" size="16" />             
              <span class="ml-1"> {{ chargeTypeMap.getText(item.type) }}</span>
            </span>
          </template>
          <template #item.duration="{ item }">
            <div class="duration-cell">
              <div class="d-flex align-center">
                <Clock :start-time="item.startTime" :end-time="item.endTime" :is-charging="item.type === 3"></Clock>
              </div>
              <div class="ml-2">
                <div class="flex">
                  <!-- <div class="text-blue-200 text-opacity-80 w-[100px]">起始时间</div> -->
                  <div>{{ item.startTime }}</div>
                </div>
                <div class="flex">
                  <!-- <div class="text-blue-200 text-opacity-80 w-[100px]">结束时间</div> -->
                  <div>{{ item.endTime }}</div>
                </div>
                <div class="flex">
                  <!-- <div class="w-[100px]">持续</div> -->
                  <div>持续 {{ item.duration }}h</div>
                </div>
              </div>
            </div>
          </template>
          <template #item.reading="{ item }">
            <div class="reading-cell">
              <div class="flex">
                <div class="text-opacity-80 w-[160px]">起始PCS读数</div>
                <div>{{ item.startEnergy }}</div>
              </div>
              <div class="flex">
                <div class="text-opacity-80 w-[160px]">结束PCS读数</div>
                <div>{{ item.endEnergy }}</div>
              </div>
              <div class="flex">
                <div class="text-opacity-80 w-[160px]">累计电能</div>
                <div :style="{ color: rechargeColor }">{{ item.energyTotal }}</div>
              </div>
            </div>
          </template>
          <template #item.socChange="{ item }">
            <div class="d-flex align-center">
              <SOCChange :start-soc="item.startSoc" :end-soc="item.endSoc" />
            </div>
          </template>
        </v-data-table>
      </div>
    </div>

    <!-- 分页 -->
    <!-- <div class="pagination-container">
      <div class="pagination-info">共 {{ pagination.total }} 项数据</div>
      <div class="pagination-controls">
        <v-select v-model="pagination.pageSize" :items="pageSizeItems" variant="outlined" density="compact"
          class="page-size-select" hide-details @update:model-value="handleSizeChange" />
        <v-pagination v-model="pagination.current" :length="totalPages" :total-visible="7" class="custom-pagination"
          @update:model-value="handlePageChange" />
        <div class="jump-to-page">
          <span>跳至</span>
          <v-text-field v-model.number="jumpPage" type="number" variant="outlined" density="compact" class="jump-input"
            hide-details @keyup.enter="handleJumpToPage" @blur="handleJumpToPage" />
          <span>/{{ totalPages }} 页</span>
        </div>
      </div>
    </div> -->
    <TablePagination v-model="pagination.current" :total="pagination.total" :page-size="pagination.pageSize"
      @change="() => fetchChargeList()" />
  </v-card>
</template>

<script setup>
import { ref, reactive, onMounted, watch, computed } from 'vue'
import dayjs from 'dayjs'
import { getChargeList, exportChargeAndDischargeRecord } from '@/api/chargeRecord'
import { getElinkStruct } from '@/api/device/elink'
import { useStationContext } from '../../composables/useStationContext'

import TablePagination from '@/components/TablePagination/index.vue'
import Clock from './components/Clock.vue'
import SOCChange from './components/SOCChange.vue'

import { ArrowUp, ArrowDown } from 'lucide-vue-next'
import { createStatusMap } from '@/utils'
// 使用 provide/inject 获取电站信息
const { stationId } = useStationContext()

// 颜色配置
const rechargeColor = '#21C976'
const dischargeColor = '#FF6C24'
const rechargeSocColor = '#647AFF'
const dischargeSocColor = '#ABC2FF'

// 充放电类型(3充电、4放电)，ps：此处状态与MQTT协议对应
const chargeTypeMap = createStatusMap({
  3: { text: '充电', bgColor: '#E7FFF3', borderColor: '#B0E2C9', textColor: '#2CAD31', component: ArrowDown },
  4: { text: '放电', bgColor: '#FFEEEE', borderColor: '#FFB1B4', textColor: '#E82E3B', component: ArrowUp },
})

// 筛选表单
// 日期范围（Element Plus 格式：['YYYY-MM-DD', 'YYYY-MM-DD']）
const dateRange = ref([])
const dateRangeStart = ref('')
const dateRangeEnd = ref('')
const filterForm = reactive({
  eLinkIds: '',
  eBlockIds: ''
})

// 能量链和能量块列表
const eLinkList = ref([])
const eBlockList = ref([])

// 表格数据
const tableData = ref([])
const loading = ref(false)

// 分页
const pagination = reactive({
  current: 1,
  pageSize: 10,
  total: 0
})

const jumpPage = ref(1)

// 计算总页数，如果没有数据也显示一页
const totalPages = computed(() => {
  const pages = Math.ceil(pagination.total / pagination.pageSize)
  return pages === 0 ? 1 : pages
})

// 每页条数选项
const pageSizeItems = [
  { title: '10 条/页', value: 10 },
  { title: '20 条/页', value: 20 },
  { title: '50 条/页', value: 50 },
  { title: '100 条/页', value: 100 }
]

// 表格列定义
const tableHeaders = [
  { title: '设备名称', key: 'equipmentName', width: '150px', sortable: false },
  { title: '充放电类型', key: 'chargeAndDischargeState', width: '130px', sortable: false },
  { title: '平均功率(kW)', key: 'avgPower', width: '150px', sortable: false },
  { title: '持续时间', key: 'duration', width: '180px', sortable: false },
  { title: '读数(kWh)', key: 'reading', width: '180px', sortable: false },
  { title: 'SOC变化(%)', key: 'socChange', width: '200px', sortable: false }
]

// 设置日期的禁选范围（半年前到今天）
function disabledDate(date) {
  const today = dayjs()
  const sixMonthsAgo = today.subtract(6, 'month')
  return dayjs(date) > today || dayjs(date) < sixMonthsAgo
}

// 处理日期范围变化
function handleDateChange(value) {
  if (value && Array.isArray(value) && value.length === 2) {
    dateRangeStart.value = `${value[0]}T00:00`
    dateRangeEnd.value = `${value[1]}T23:59`
  } else {
    dateRangeStart.value = ''
    dateRangeEnd.value = ''
  }
}


// 更新能量链列表
const updateElinkList = async (stationId) => {
  if (!stationId) return
  try {
    const res = await getElinkStruct(stationId)
    if (res.code === 200 && Array.isArray(res.data)) {
      eLinkList.value = res.data.map(item => ({
        label: item.equipmentName,
        value: item.uuid,
        list: item.list || []
      }))
      if (eLinkList.value.length > 0) {
        filterForm.eLinkIds = eLinkList.value[0].value
        updateEblockList(eLinkList.value[0].value)
        // 数据加载完成后自动查询
        handleSearch()
      }
    }
  } catch (error) {
    console.error('获取能量链列表失败:', error)
  }
}

// 能量链变化
const elinkChanged = (value) => {
  updateEblockList(value)
  handleSearch()
}

// 更新能量块列表
const updateEblockList = (elinkId) => {
  const elink = eLinkList.value.find(item => item.value === elinkId)
  if (elink && elink.list && Array.isArray(elink.list)) {
    // 添加"全部"选项
    eBlockList.value = [
      { label: '全部', value: 'all' },
      ...elink.list.map(item => ({
        label: item.equipmentName,
        value: item.uuid
      }))
    ]
    // 默认选择"全部"
    filterForm.eBlockIds = 'all'
  } else {
    eBlockList.value = [{ label: '全部', value: 'all' }]
    filterForm.eBlockIds = 'all'
  }
}

// 格式化日期时间为API需要的格式 (YYYY-MM-DD HH:mm:ss)
const formatDateTimeForAPI = (dateTimeString) => {
  if (!dateTimeString) return undefined
  if (dateTimeString.includes('T')) {
    return dateTimeString.replace('T', ' ') + ':00'
  }
  if (dateTimeString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/)) {
    return dateTimeString + ':00'
  }
  return dateTimeString
}

// 获取列表数据
const fetchChargeList = async () => {
  if (!stationId.value) {
    tableData.value = []
    pagination.total = 0
    return
  }

  if (!filterForm.eBlockIds || filterForm.eBlockIds === '') {
    tableData.value = []
    pagination.total = 0
    return
  }

  if (!dateRangeStart.value || !dateRangeEnd.value) {
    return
  }

  // 如果选择的是"全部"，需要获取当前能量链下的所有能量块的uuid
  let uuids = filterForm.eBlockIds
  if (filterForm.eBlockIds === 'all') {
    if (!filterForm.eLinkIds) {
      tableData.value = []
      pagination.total = 0
      return
    }
    const elink = eLinkList.value.find(item => item.value === filterForm.eLinkIds)
    if (elink && elink.list && Array.isArray(elink.list) && elink.list.length > 0) {
      uuids = elink.list.map(item => item.uuid).join(',')
    } else {
      tableData.value = []
      pagination.total = 0
      return
    }
  }

  loading.value = true
  try {
    const startTimeFormatted = formatDateTimeForAPI(dateRangeStart.value)
    const endTimeFormatted = formatDateTimeForAPI(dateRangeEnd.value)
    const params = {
      pageSize: pagination.pageSize,
      pageNum: pagination.current,
      startTime: startTimeFormatted ? startTimeFormatted.replace(/:\d{2}$/, ':00') : undefined,
      endTime: endTimeFormatted ? endTimeFormatted.replace(/:\d{2}$/, ':59') : undefined,
      stationId: stationId.value,
      uuids: uuids
    }
    const res = await getChargeList(params)

    if (res.code == 200) {
      tableData.value = (res.rows || []).map(item => ({
        key: item.id || `${item.startTime}_${item.equipmentName}`,
        equipmentName: item.equipmentName || '',
        type: item.type,
        avgPower: item.avgPower || '0',
        startTime: item.startTime || '',
        endTime: item.endTime || '',
        duration: item.duration || '0',
        startEnergy: item.startEnergy || '0',
        endEnergy: item.endEnergy || '0',
        energyTotal: item.energyTotal || '0',
        startSoc: item.startSoc || 0,
        endSoc: item.endSoc || 0
      }))
      pagination.total = res.total || 0
    }
  } catch (error) {
    console.error('获取充放记录失败:', error)
    tableData.value = []
    pagination.total = 0
  } finally {
    loading.value = false
  }
}

// 查询
const handleSearch = () => {
  fetchChargeList()
}

// 重置
const handleReset = () => {
  const today = dayjs().format('YYYY-MM-DD')
  dateRange.value = [today, today]
  dateRangeStart.value = `${today}T00:00`
  dateRangeEnd.value = `${today}T23:59`
  if (eLinkList.value.length > 0) {
    filterForm.eLinkIds = eLinkList.value[0].value
    updateEblockList(eLinkList.value[0].value)
  } else {
    filterForm.eLinkIds = ''
    filterForm.eBlockIds = 'all'
  }
  pagination.current = 1
  handleSearch()
}

// 导出
const handleExport = async () => {
  // 如果选择的是"全部"，需要获取当前能量链下的所有能量块的uuid
  let uuids = filterForm.eBlockIds
  if (filterForm.eBlockIds === 'all') {
    const elink = eLinkList.value.find(item => item.value === filterForm.eLinkIds)
    if (elink && elink.list && Array.isArray(elink.list) && elink.list.length > 0) {
      uuids = elink.list.map(item => item.uuid).join(',')
    }
  }

  try {
    const startTimeFormatted = formatDateTimeForAPI(dateRangeStart.value)
    const endTimeFormatted = formatDateTimeForAPI(dateRangeEnd.value)
    const params = {
      startTime: startTimeFormatted ? startTimeFormatted.replace(/:\d{2}$/, ':00') : undefined,
      endTime: endTimeFormatted ? endTimeFormatted.replace(/:\d{2}$/, ':59') : undefined,
      stationId: stationId.value,
      uuids: uuids
    }
    await exportChargeAndDischargeRecord(params)
  } catch (error) {
    console.error('导出充放记录失败:', error)
  }
}

// 分页变化
const handleSizeChange = (size) => {
  pagination.pageSize = size
  pagination.current = 1
  jumpPage.value = 1
  fetchChargeList()
}

const handlePageChange = (page) => {
  pagination.current = page
  jumpPage.value = page
  fetchChargeList()
}

// 跳转到指定页
const handleJumpToPage = () => {
  if (jumpPage.value >= 1 && jumpPage.value <= totalPages.value) {
    pagination.current = jumpPage.value
    fetchChargeList()
  } else {
    // 如果输入无效，重置为当前页
    jumpPage.value = pagination.current
  }
}

// 监听 stationId 变化
watch(() => stationId.value, (newVal) => {
  if (newVal) {
    updateElinkList(newVal)
  } else {
    eLinkList.value = []
    eBlockList.value = []
    filterForm.eLinkIds = ''
    filterForm.eBlockIds = ''
  }
})

onMounted(() => {
  // 初始化日期为今天
  const today = dayjs()
  const todayStr = today.format('YYYY-MM-DD')
  dateRange.value = [todayStr, todayStr]
  dateRangeStart.value = `${todayStr}T00:00`
  dateRangeEnd.value = `${todayStr}T23:59`

  if (stationId.value) {
    updateElinkList(stationId.value)
  }
})
</script>

<style scoped lang="scss">
.charge-record {
  display: flex;
  flex-direction: column;
  height: calc(100vh - var(--header-height) - 150px);
  // border: 1px solid red;
  gap: 0;
  padding: 0;
  background: #fff;
  overflow: hidden;
  padding-bottom: 16px;
  min-width: 0;
  max-width: 100%;
}

.filter-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 0;
  padding: 16px 24px;
  background: #fff;
  flex-shrink: 0;
  flex-wrap: wrap;
  overflow-x: visible;
  min-height: 72px;

  :deep(.v-select__selection-text) {
    max-width: 34px;
  }
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
  margin-right: 24px;
  height: 40px;
}

.filter-label {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #2e2e2e;
  white-space: nowrap;
  flex-shrink: 0;
  line-height: 40px;
  height: 40px;
  display: flex;
  align-items: center;
}

.filter-date-picker {
  width: 230px !important;
  min-width: 180px !important;
  max-width: 230px !important;

  :deep(.el-input__wrapper) {
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    padding: 0 16px;
    min-height: 40px;
    height: 40px;
    transition: border-color 0.2s;

    &.is-focus {
      border-color: var(--color-primary);
    }
  }

  :deep(.el-input__inner) {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    height: 40px;
    line-height: 40px;

    &::placeholder {
      color: rgba(46, 46, 46, 0.5);
      font-weight: 400;
      font-family: "HarmonyOS Sans SC", sans-serif;
    }
  }

  :deep(.el-input__suffix) {
    color: rgba(46, 46, 46, 0.5);
  }
}

:deep(.el-range-editor) {
  width: 230px !important;
  min-width: 180px !important;
  max-width: 230px !important;
  background: #fff;
  border: 2px solid #c0cfda4d;
  border-radius: 20px;
  align-items: center;
  margin: 0;
  display: flex;
  box-shadow: 0 1px 2px #0000000d;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
}

:deep(.el-range-editor:focus-within) {
  border-color: var(--color-primary);
}

:deep(.el-date-editor) {
  .el-range__close-icon {
    display: none !important;
  }
}

// 选中日期时的颜色
:deep(.el-date-editor.el-input__wrapper:hover) {
  box-shadow: none !important;
}

.filter-label.date-label {
  color: #2E2E2E;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.filter-select {
  width: 230px;
  min-width: 180px;
  max-width: 230px;

  :deep(.v-field) {
    min-height: 40px !important;
    height: 40px !important;
    max-height: 40px !important;
    background: #fff;
    border: 1px solid rgba(192, 207, 218, 0.3);
    border-radius: 20px;
    display: flex;
    align-items: center;
    margin: 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    min-width: 0;
  }

  :deep(.v-field__input) {
    padding: 8px 0px 8px 16px;
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    display: flex;
    align-items: center;
    min-width: 0;
    flex: 1;
  }

  // :deep(.v-field__outline) {
  //   display: none;
  // }

  :deep(.v-select__selection) {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    color: #2E2E2E;
    line-height: 24px;
    display: flex;
    align-items: center;
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  :deep(.v-select__selection-text) {
    white-space: nowrap;
    overflow: visible;
    text-overflow: clip;
    max-width: none;
    flex: 1;
    min-width: 0;
  }

  :deep(.v-field__append-inner) {
    flex-shrink: 0;
  }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-left: auto;
  flex-shrink: 0;
  height: 40px;
}

.query-btn {
  width: 98px;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  border-radius: 12px !important;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  background: #3a68ff !important;
  color: #fff !important;
  text-transform: none !important;
  padding: 0 !important;
  border: none !important;
  box-shadow: none !important;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .query-icon {
    width: 13px;
    height: 13px;
    margin-inline-end: 6px;
    display: inline-block;
    flex-shrink: 0;
  }

  &:hover {
    background: #3a68ff !important;
    opacity: 0.9;
  }

  &:active {
    background: #3a68ff !important;
    opacity: 0.8;
  }
}

.export-btn,
.clear-btn {
  width: 98px;
  height: 40px !important;
  min-height: 40px !important;
  max-height: 40px !important;
  border-radius: 12px !important;
  border: 1px solid rgba(192, 207, 218, 0.3) !important;
  font-family: "HarmonyOS Sans SC", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #2e2e2e !important;
  background: #fff !important;
  text-transform: none !important;
  padding: 0 !important;
  box-shadow: none !important;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  .export-icon {
    width: 12px;
    height: 12px;
    margin-inline-end: 6px;
    display: inline-block;
    flex-shrink: 0;
  }

  .reset-icon {
    width: 13px;
    height: 13px;
    margin-inline-end: 6px;
    display: inline-block;
    flex-shrink: 0;
  }
}

.table-container {
  flex: 1;
  min-height: 0;
  min-width: 0;
  background: #fff;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 0;
}

.table-wrapper {
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: auto;
  padding: 0 24px;
}

.charge-table {
  width: 100%;
  flex: 1;
  min-height: 0;

  :deep(.v-data-table) {
    background: transparent;
  }

  :deep(.v-table__wrapper) {
    overflow-x: auto;
  }

  :deep(table) {
    min-width: 990px;
  }

  :deep(.v-data-table__thead) {
    th {
      background: transparent !important;
      color: #96a5b8;
      font-family: "HarmonyOS Sans SC", sans-serif;
      font-size: 13px;
      font-weight: 400;
      font-style: normal;
      padding: 12px 0;
      border-bottom: none;
      line-height: 16px;
      text-align: left;

      .v-data-table-header__content {
        color: #96a5b8;
        font-family: "HarmonyOS Sans SC", sans-serif;
        font-size: 13px;
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
      }
    }
  }

  :deep(.v-data-table__tbody) {
    tr {
      td {
        color: #444a6d;
        font-family: 'PingFang SC', sans-serif;
        font-size: 14px;
        font-weight: 400;
        padding: 12px 0;
        border-bottom: none;
        line-height: 1.5;
      }
    }

    tr:nth-child(even) {
      background: #edf2f6 !important;
    }

    tr:nth-child(odd) {
      background: transparent !important;
    }

    tr:hover {
      background: #f0f4f8 !important;
    }
  }
}

.charge-type-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 65px;
  height: 24px;
  text-align: center;
  border-radius: 42px;
  border: 1px solid;

  .circle-symbol {
    width: 10px;
    height: 10px;
    background-color: currentColor;
    border-radius: 50%;
    margin: 0 10px;
    box-shadow: 0 0 10px currentColor;
  }
}

.duration-cell,
.reading-cell,
.soc-cell {
  display: flex;
  flex-direction: column;
  // gap: 8px;
  margin: 12px 0;
}
.duration-cell {
  flex-direction: row;
}
.soc-item {
  flex-direction: row;
}

.flex {
  display: flex;
  align-items: center;
  margin: 4px 0;
}

.text-blue-200 {
  color: #3a68ff;
}

.text-opacity-80 {
  opacity: 0.8;
}

.w-\[100px\] {
  width: 100px;
}

.w-\[160px\] {
  width: 160px;
}

.soc-item {
  display: flex;
  // flex-direction: column;
  gap: 4px;
  align-items: center;
}

.soc-progress-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
  // margin-top: 4px;
}

.recharge-progress,
.discharge-progress {
  flex: 1;
  margin-top: 0;
}

.soc-percentage {
  font-size: 14px;
  white-space: nowrap;
  min-width: 40px;
  text-align: right;
}

@media (max-width: 1366px) {
  .filter-bar {
    padding: 14px 16px;
    gap: 12px;
  }

  .filter-item {
    margin-right: 0;
  }

  .filter-actions {
    margin-left: 0;
  }

  .table-wrapper {
    padding: 0 16px;
  }
}

@media (max-width: 768px) {
  .filter-bar {
    align-items: flex-start;
  }

  .filter-item,
  .filter-actions {
    width: 100%;
    height: auto;
    flex-wrap: wrap;
  }

  .filter-date-picker,
  .filter-select {
    width: 100% !important;
    max-width: 100% !important;
  }

  :deep(.el-range-editor) {
    width: 100% !important;
    max-width: 100% !important;
  }

  .query-btn,
  .export-btn,
  .clear-btn {
    flex: 1 1 0;
    min-width: 86px;
  }
}

.pagination-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 24px;
  background: #fff;
  flex-shrink: 0;
  border-top: 1px solid #f0f0f0;

  :deep(.v-btn--disabled) {
    color: #fff !important;
    opacity: 1 !important;
  }
}

.pagination-info {
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
  line-height: 22px;
  letter-spacing: 0%;
  color: rgba(0, 0, 0, 0.6);
  vertical-align: middle;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 16px;
  height: 100%;
}

.page-size-select {
  width: 112px;
  flex-shrink: 0;

  :deep(.v-field) {
    background: #fff !important;
    border: 1px solid #dcdcdc !important;
    border-radius: 3px !important;
    min-height: auto !important;
    height: auto !important;
    padding: 5px 8px !important;
    box-shadow: none !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-field__input) {
    padding: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    min-height: auto !important;
    height: 22px !important;
    line-height: 22px !important;
    display: flex !important;
    align-items: center !important;
  }

  :deep(.v-select__selection) {
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    color: rgba(0, 0, 0, 0.9) !important;
    line-height: 22px !important;
    margin: 0 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  :deep(.v-field__outline) {
    display: none !important;
  }

  :deep(.v-field__append-inner .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: #2E2E2E !important;
    opacity: 0.22;
  }
}

.custom-pagination {
  flex-shrink: 0;

  :deep(.v-pagination__list) {
    align-items: center;
    gap: 8px !important;
    margin: 0 !important;
  }

  :deep(.v-btn) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    margin: 0 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    line-height: 22px !important;
    border: none !important;
    background: transparent !important;
    color: #000000E6 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 0 !important;
    transition: none !important;
    box-shadow: none !important;
    text-align: center !important;

    &:hover {
      background: transparent !important;
      color: #000000E6 !important;
    }

    &.v-pagination__item--is-active {
      color: #000000E6 !important;
      border: none !important;
      box-shadow: none !important;
    }

    .v-pagination__item--text {
      line-height: 22px !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 14px !important;
      color: #000000E6 !important;
    }
  }

  :deep(.v-pagination__prev),
  :deep(.v-pagination__next) {
    min-width: 32px !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    transition: none !important;
    box-shadow: none !important;

    &:hover:not(.v-pagination__item--disabled) {
      background: transparent !important;
    }

    &.v-pagination__item--disabled {
      opacity: 0.4 !important;
      cursor: not-allowed !important;
    }
  }

  :deep(.v-pagination__prev .v-icon),
  :deep(.v-pagination__next .v-icon) {
    font-size: 16px !important;
    width: 16px !important;
    height: 16px !important;
    color: rgba(0, 0, 0, 1) !important;
  }

  /* 省略号（ellipsis）样式 */
  :deep(.v-pagination__item--ellipsis) {
    border: none !important;
    background: #fff !important;
    color: #000000E6 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
  }

  :deep(.v-btn--variant-text) {
    border: none !important;
    background: transparent !important;
    color: #000000E6 !important;
    font-family: 'PingFang SC', sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    box-shadow: none !important;

    &:active,
    &:focus {
      box-shadow: none !important;
      background: transparent !important;
    }
  }
}

.jump-to-page {
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'PingFang SC', sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  background: #e3e3e3;
  padding: 2px 16px;
  border-radius: 3px;
  line-height: 22px;
  height: 34px;
  width: 160px;
  flex-shrink: 0;

  span {
    white-space: nowrap;
    line-height: 22px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }

  .jump-input {
    flex: 1 0 0;
    min-width: 0;

    :deep(.v-field) {
      background: #fff !important;
      border: 1px solid #dcdcdc !important;
      border-radius: 3px !important;
      min-height: auto !important;
      height: auto !important;
      margin: 0 !important;
      box-shadow: none !important;
      display: flex !important;
      align-items: center !important;
    }

    :deep(.v-field__input) {
      padding: 0 !important;
      text-align: center !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      color: rgba(0, 0, 0, 0.9) !important;
      min-height: auto !important;
      height: 22px !important;
      line-height: 22px !important;
    }

    :deep(.v-field__outline) {
      display: none !important;
    }

    :deep(input) {
      text-align: center !important;
      padding: 0 !important;
      margin: 0 !important;
    }

    /* 隐藏数字输入框的上下箭头 */
    :deep(input[type="number"]) {

      &::-webkit-inner-spin-button,
      &::-webkit-outer-spin-button {
        -webkit-appearance: none !important;
        margin: 0 !important;
        display: none !important;
      }
    }
  }
}

:deep(.v-input__details) {
  display: none;
}

:deep(.v-table__wrapper) {
  tr th {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 13px;
    font-weight: 400;
    font-style: normal;
    line-height: 16px;
    letter-spacing: 0px;
    color: #96A5B8;
  }

  tbody tr td {
    font-family: "HarmonyOS Sans SC", sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-style: normal;
    line-height: 100%;
    letter-spacing: 0px;
    color: #444A6D;
  }
}
</style>

<style lang="scss">
.charge-record-filter-select-menu {
  border-radius: 10px !important;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  margin-top: 4px !important;
  overflow: hidden !important;
  border: 1px solid rgba(224, 228, 231, 1) !important;

  .v-list {
    background: #fff !important;
    border-radius: 10px !important;
    padding: 4px 0 !important;

    .v-list-item {
      min-height: auto !important;
      padding: 8px 12px !important;
      color: rgba(46, 46, 46, 1) !important;
      font-family: 'PingFang SC', sans-serif !important;
      font-size: 13px !important;
      font-weight: 400 !important;
      line-height: 24px !important;
      transition: background-color 0.2s ease, color 0.2s ease !important;
      cursor: pointer !important;
      text-align: left !important;

      &:hover {
        background-color: #f5f7fa !important;
        color: rgba(58, 104, 255, 1) !important;
      }

      .v-list-item__title {
        font-family: 'PingFang SC', sans-serif !important;
        font-size: 13px !important;
        font-weight: 400 !important;
        color: inherit !important;
        line-height: 24px !important;
      }
    }

    // 活动项样式（使用 active-class）
    .filter-select-active,
    .v-list-item--active {
      background-color: #f5f7fa !important;
      color: rgba(58, 104, 255, 1) !important;

      .v-list-item__title {
        color: rgba(58, 104, 255, 1) !important;
      }
    }
  }
}
</style>
